var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcCloseBlack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F7437320-1BC0-475B-992D-DAA283972D80") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.00.03-General-Info:-Scroll",
    transform: "translate(-114.000000, -226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attached-Photos",
    transform: "translate(24.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Voter-Card",
    transform: "translate(16.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(70.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(4.615385, 4.615385)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bg",
    fillOpacity: 0,
    fill: "#D8D8D8",
    points: "0 0 14.7692308 0 14.7692308 14.7692308 0 14.7692308"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.3076923,
    y1: 2.46153846,
    x2: 2.46153846,
    y2: 12.3076923,
    id: "Shape",
    stroke: "#333333",
    strokeWidth: 0.923076923,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.46153846,
    y1: 2.46153846,
    x2: 12.3076923,
    y2: 12.3076923,
    id: "Shape",
    stroke: "#333333",
    strokeWidth: 0.923076923,
    strokeLinecap: "round"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcCloseBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_close_black.8cd6644ce93f39ab77895d385318e243.svg";